import React from "react";
import { useTranslation } from "react-i18next";
import PropTypes from "prop-types";
import FullWidthTabs from "../FullWidthTabs/FullWidthTabs";
import InterestForChosenDateTab from "./InterestForChosenDateTab";
import InterestByYearTab from "./InterestByYearTab/InterestByYearTab";
import { APP_STAGE } from "../../../helpers/constants";




const IcoReportsTabs = React.memo((props) => {
  const { t } = useTranslation();


  return (
    <FullWidthTabs
      cleanFilters={true}
      items={
        [
        {
          label: t("tabs.ico_reports_tab.interest_for_chosen_date"),
          content: (
            <InterestForChosenDateTab />
          ),
        },
     {
          label: t("tabs.ico_reports_tab.bo_bz_report"),
          content: (
            <InterestByYearTab/>
          ),
        },
      ]
    }
    />
  );
});

IcoReportsTabs.propTypes = {
  pageName: PropTypes.string,
  readOnly: PropTypes.bool,
};

IcoReportsTabs.defaultProps = {
  readOnly: false,
};

export default IcoReportsTabs;
